import {getStringProperty} from "./property";

export const getAddressFromListing = (listing, isComplete = false) => {
	let address = listing?.property?.address?.fullAddress
	if (isComplete) {
		address += ". " + getStringProperty(listing?.property)
	}
	return address
}